import React, { useEffect, useRef, useState } from 'react'
import { Link, useNavigate, useParams, useLocation } from 'react-router-dom'
import { get, post } from '../../../utils/apiManager'
import {
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CHeader,
  CTable,
  CRow,
  CTableHead,
  CTableRow,
  CTableHeaderCell,
  CTableBody,
  CTableDataCell,
  CButton,
} from '@coreui/react'
import { ToastContainer, toast } from 'react-toastify'
import { FaArrowLeft } from 'react-icons/fa'
import { ImageUrl, ImageUrl2 } from 'src/config/config'
import ItemImagePreview from './itemImagePreview'
import ImagePreview from './previewImage'
import ItemScanModal from './ItemScanModal'
import OrderComplete from './orderComplete'
import OrderNotFound from 'src/components/LaundryProcessModals/OrderNotFound'
import ItemImagePreviewStain from './itemImagePreviewStain'

function BagList() {
  const navigate = useNavigate()
  let inputScannerRef = useRef()
  const scrollPosRef = useRef(0)
  const [visible, setVisible] = useState(false)
  const [logo, setLogo] = useState()
  const [stainImage, setStainImage] = useState([])
  const [stainArray, setStainArray] = useState([])
  const [visiblePreview, setVisiblePreview] = useState(false)
  const [itemPicture, setItemPicture] = useState('')
  const [successModal, setSuccessModal] = useState(false)
  const [allTotalItems, setAllTotalItems] = useState(0)
  const [scanModelShow, setScanModelShow] = useState(false)
  const [totalCompleteItems, setTotalCompleteItems] = useState(0)
  const [incompleteLength, setIncompleteLength] = useState(0)
  const [newOrderId, setNewOrderId] = useState()
  const [barcodeValue, setBarcodeValue] = useState('')
  const [manualBarcode, setManualBarcode] = useState('')
  const [order, setOrder] = useState()
  const [notFoundModal, setNotFoundModal] = useState(false)

  const [pageData, setPageData] = useState({
    page: 1,
    perPage: 10,
    searchItem: '',
  })
  const { state } = useLocation()
  const { orderId, _id } = state
  const [numberOrderId, setNumberOrderId] = useState(orderId)
  const getData = (checkAllOrderComplete) => {
    get(`/admin/placed-order/order-details?orderId=${orderId}&checkValue=true`).then((res) => {
      if (res?.status) {
        setOrder(res?.data)
        setNewOrderId(res?.data?.[0]?.orderId)

        if (checkAllOrderComplete) {
          checkAllItemsScanned(res?.data)
        }
        let k = 0
        let r = 0
        let j = 0
        let totalItems = res?.data?.forEach((item) => {
          if (item?.service_id != null) {
            k += item?.items?.length
            if (item?.items?.length > 0) {
              item?.items?.forEach((data) => {
                if (data?.isCompleted) {
                  r += 1
                } else if (!data?.isCompleted) {
                  j += 1
                }
              })
            }
          }
        })
        if (k == r) {
          setSuccessModal(true)
        }
        setAllTotalItems(k)
        setIncompleteLength(j)
        setTotalCompleteItems(r)
        setNumberOrderId(res?.data?.[0]?.orderId)
      }
    })
  }
  const checkAllItemsScanned = (allData) => {
    get(`/admin/placed-order/check-is-order-completed?orderId=${orderId}`)
      .then((res) => {
        if (res?.status) {
          if (res?.message != 'Some items in the order are not completed') {
            setSuccessModal(true)
          }
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }
  useEffect(() => {
    getData()
    getLogo()
  }, [pageData])

  const getLogo = () => {
    get(`/admin/global/global-setting`).then((response) => {
      if (response?.status == true) {
        setLogo(`${ImageUrl}${response.data.logoImage}`)
      }
    })
  }

  const showTotal = (item) => {
    if (item?.serviceName_EN != 'Add Ons') {
      let count = item?.items?.reduce((accumulator, currentItem) => {
        if (currentItem?.isCompleted) {
          return accumulator + 1
        } else {
          return accumulator
        }
      }, 0)
      return `${count}/${item?.items?.length}`
    }
  }
  useEffect(() => {
    if (incompleteLength > 0) {
      setScanModelShow(true)
    }
  }, [incompleteLength])
  useEffect(() => {
    if (!barcodeValue || barcodeValue.length === 0) return;
    const debounceTimer = setTimeout(() => {
      changeStatus();
    }, 500); // Adjust delay as needed
    return () => clearTimeout(debounceTimer); // Cleanup on value change
  }, [barcodeValue]);
  useEffect(() => {
    inputScannerRef.current?.focus({ preventScroll: true })
  }, [])

  useEffect(() => {
    if (!visible && !visiblePreview && scrollPosRef.current > 0) {
      const savedTop = scrollPosRef.current
      requestAnimationFrame(() => {
        window.scrollTo({ top: savedTop, behavior: 'instant' })
      })
    }
  }, [visible, visiblePreview])

  const submitBarcode = (codeToSubmit) => {
    const code = (codeToSubmit || '').toString().trim()
    if (!code) {
      toast.warning('Please enter a barcode number')
      return
    }
    const currentOrderId = numberOrderId || orderId || (order && order[0]?.orderId)
    get(
      `/admin/placed-order/mark-item-as-completed?itemCode=${code}&orderId=${currentOrderId}`,
    )
      .then((res) => {
        if (res?.response?.data?.status === false || res?.status === false) {
          toast.error(res?.message || res?.response?.data?.message || 'Item not found in this order')
          setNotFoundModal(true)
          setManualBarcode('')
          setBarcodeValue('')
        } else {
          toast.success('Item verified successfully!')
          getData(true)
          if (typeof handleModalClose === 'function') handleModalClose()
          setManualBarcode('')
          setBarcodeValue('')
        }
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || 'Item not found in this order')
        setManualBarcode('')
        setBarcodeValue('')
      })
  }

  const changeStatus = () => {
    if (!barcodeValue) return
    submitBarcode(barcodeValue)
  }

  const getStainThumbnail = (item) => {
    if (item?.stain && Array.isArray(item.stain)) {
      for (const s of item.stain) {
        if (s?.images && Array.isArray(s.images) && s.images.length > 0 && s.images[0]) {
          return s.images[0]
        }
      }
    }
    if (item?.stain_image && Array.isArray(item.stain_image) && item.stain_image.length > 0) {
      return item.stain_image[0]
    }
    return null
  }

  return (
    <>
      <ToastContainer position={toast.POSITION.TOP_RIGHT} autoClose={2000} />
      <CContainer fluid>
        <CRow>
          <CCol>
            <CCardGroup>
              <CCard
                className="p-4"
                onClick={(e) => {
                  if (
                    e.target.tagName !== 'INPUT' &&
                    e.target.tagName !== 'BUTTON' &&
                    e.target.tagName !== 'IMG' &&
                    !e.target.closest('input') &&
                    !e.target.closest('button') &&
                    !e.target.closest('img') &&
                    !e.target.closest('.modal') &&
                    !visible &&
                    !visiblePreview
                  ) {
                    inputScannerRef.current?.focus({ preventScroll: true })
                  }
                }}
              >
                <CHeader>
                  <div className="d-flex align-items-center justify-content-between w-100 flex-wrap gap-2">
                    <div className="d-flex align-items-center">
                      <FaArrowLeft
                        style={{ color: '#000', cursor: 'pointer', marginRight: '10px', fontSize: '18px' }}
                        onClick={() => {
                          navigate('/admin/checkout-orders')
                        }}
                      />
                      <span style={{ fontSize: '18px', fontWeight: 'bold' }}> Bags </span>
                    </div>

                    <div
                      className="d-flex align-items-center gap-2"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Barcode Number..."
                        value={manualBarcode}
                        onChange={(e) => setManualBarcode(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            e.preventDefault()
                            submitBarcode(manualBarcode)
                          }
                        }}
                        style={{ width: '230px', height: '38px', borderRadius: '4px' }}
                      />
                      <button
                        type="button"
                        className="btn btn-success"
                        style={{
                          background: '#d3dc40',
                          borderColor: '#d3dc40',
                          color: '#000',
                          fontWeight: '600',
                          height: '38px',
                          padding: '0 16px',
                          whiteSpace: 'nowrap',
                        }}
                        onClick={() => submitBarcode(manualBarcode)}
                      >
                        Submit
                      </button>
                    </div>

                    {/* Hidden input to support hardware gun barcode scanners */}
                    <input
                      type="text"
                      ref={inputScannerRef}
                      value={barcodeValue}
                      onChange={(e) => {
                        if (!/^[a-zA-Z0-9]+$/.test(e.target.value)) {
                          return
                        }
                        setBarcodeValue(e.target.value)
                      }}
                      style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        opacity: 0,
                        width: '1px',
                        height: '1px',
                        pointerEvents: 'none',
                        zIndex: -1,
                      }}
                    />
                  </div>
                </CHeader>
                <CCardBody>
                  <CCol>
                    <span className="d-flex justify-content-end">
                      {' '}
                      Total Items : {totalCompleteItems}/{allTotalItems}
                    </span>
                  </CCol>

                  {order?.map((ord, idx) => (
                    <>
                      <br />
                      <h4>{ord?.service_id != null && `Bag ${idx + 1}`}</h4>
                      <div className="d-flex align-items-center justify-content-between">
                        <h6>{ord?.serviceName_EN}</h6>
                        <h6>{showTotal(ord)} </h6>
                      </div>
                      <CTable bordered hover responsive>
                        <CTableHead>
                          <CTableRow>
                            <CTableHeaderCell>Barcode</CTableHeaderCell>
                            <CTableHeaderCell>Item Name</CTableHeaderCell>
                            <CTableHeaderCell>Brands</CTableHeaderCell>
                            <CTableHeaderCell>Colors</CTableHeaderCell>
                            <CTableHeaderCell>Description</CTableHeaderCell>
                            <CTableHeaderCell>Service</CTableHeaderCell>
                            <CTableHeaderCell>Picture</CTableHeaderCell>
                            <CTableHeaderCell>Stain</CTableHeaderCell>
                            <CTableHeaderCell>Stain Image</CTableHeaderCell>
                            {/* {ord?.serviceName_EN != "Add Ons" &&
                                                            <CTableHeaderCell>Scan</CTableHeaderCell>
                                                        } */}
                          </CTableRow>
                        </CTableHead>
                        <CTableBody>
                          {ord?.items?.map((item, index) => {
                            return (
                              <CTableRow
                                key={index}
                                color={
                                  ord?.serviceName_EN != 'Add Ons'
                                    ? item.isCompleted
                                      ? 'success'
                                      : 'danger'
                                    : ''
                                }
                              >
                                <CTableDataCell>{item?.itemCode || 'N/A'} </CTableDataCell>
                                <CTableDataCell>{item?.itemName_EN || 'N/A'}</CTableDataCell>
                                <CTableDataCell>{item?.brand || 'N/A'}</CTableDataCell>
                                <CTableDataCell>
                                  {item?.colorInfo?.length > 0
                                    ? item?.colorInfo?.map(
                                      (color, i) =>
                                        `${color.name}${item?.colorInfo?.length > i + 1 ? ',' : ''
                                        } `,
                                    )
                                    : 'N/A'}
                                </CTableDataCell>
                                <CTableDataCell>{item?.description || 'N/A'}</CTableDataCell>
                                <CTableDataCell>{ord?.serviceName_EN || 'N/A'}</CTableDataCell>
                                <CTableDataCell>
                                  {item?.item_image ? (
                                    <img
                                      src={ImageUrl + item.item_image}
                                      alt="Garment"
                                      style={{
                                        width: '45px',
                                        height: '45px',
                                        objectFit: 'cover',
                                        borderRadius: '4px',
                                        cursor: 'pointer',
                                        border: '1px solid #ddd',
                                      }}
                                      onClick={(e) => {
                                        e.stopPropagation()
                                        scrollPosRef.current = window.scrollY || document.documentElement.scrollTop
                                        setItemPicture(item.item_image)
                                        setVisible(true)
                                      }}
                                    />
                                  ) : (
                                    <span className="text-muted">N/A</span>
                                  )}
                                </CTableDataCell>
                                <CTableDataCell>
                                  {item?.stain?.length ? item?.stain?.map((s) => s.stainName || 'N/A').join(", ") : 'N/A'}
                                </CTableDataCell>
                                <CTableDataCell>
                                  {(() => {
                                    const stainThumb = getStainThumbnail(item)
                                    return stainThumb ? (
                                      <img
                                        src={ImageUrl + stainThumb}
                                        alt="Stain"
                                        style={{
                                          width: '45px',
                                          height: '45px',
                                          objectFit: 'cover',
                                          borderRadius: '4px',
                                          cursor: 'pointer',
                                          border: '1px solid #ddd',
                                        }}
                                        onClick={(e) => {
                                          e.stopPropagation()
                                          scrollPosRef.current = window.scrollY || document.documentElement.scrollTop
                                          if (item?.stain) {
                                            setStainArray(item.stain)
                                            setVisiblePreview(true)
                                          }
                                        }}
                                      />
                                    ) : (
                                      <span className="text-muted">N/A</span>
                                    )
                                  })()}
                                </CTableDataCell>

                                {/* {ord?.serviceName_EN != "Add Ons" &&
                                                                    <CTableDataCell>
                                                                        <ItemScanModal item={item} orderId={orderId} refresh={getData} />
                                                                    </CTableDataCell>
                                                                } */}
                              </CTableRow>
                            )
                          })}
                        </CTableBody>
                      </CTable>
                    </>
                  ))}

                  {/*     {
                                        scanModelShow &&
                                        // <CTableDataCell>
                                        <ItemScanModal
                                            // item={item} 
                                            orderId={newOrderId}
                                            refresh={getData}
                                            scanModelShow={scanModelShow}
                                            setScanModelShow={setScanModelShow}
                                            setAllTotalItems={setAllTotalItems}
                                            setTotalCompleteItems={setTotalCompleteItems}
                                            setSuccessModal={setSuccessModal}
                                            setOrder={setOrder}
                                        />
                                        // </CTableDataCell>
                                    }
                                */}

                  {!order?.length && (
                    <>
                      <h1>No Data</h1>
                    </>
                  )}
                </CCardBody>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
        <ImagePreview visible={visible} setVisible={setVisible} image={ImageUrl + itemPicture} />
        <ItemImagePreviewStain
          stain={stainArray}
          visiblePreview={visiblePreview}
          setVisiblePreview={setVisiblePreview}
          image={stainImage}
        />
        {successModal ? <OrderComplete visible={successModal} setVisible={setSuccessModal} orderId={numberOrderId} /> : ''}
        {notFoundModal ? (
          <OrderNotFound
            orderId={orderId}
            inputScannerRef={inputScannerRef}
            visible={notFoundModal}
            setVisible={setNotFoundModal}
          />
        ) : (
          ''
        )}
      </CContainer>
    </>
  )
}

export default BagList
